module.exports = __webpack_public_path__ + "static/media/eps.2028b595.png";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Marketing/Prints/images/eps.png
// module id = 799
// module chunks = 1